import { GetNewslettersQuery_newsletters_Newsletter } from '__generated__/queries-newsletter';
import { NlfNewsletters, NlfSection } from 'types';

const extractSectionData = (nflSections: NlfSection) => {
  const sections: { sectionResourceCount: number }[] = [];
  nflSections &&
    Object.keys(nflSections).forEach((section: string) => {
      let sections2Content = 0;
      let sectionsContent = 0;
      nflSections[section].forEach((value) => {
        if (value.indexOf('2content') !== -1) {
          sections2Content = sections2Content + 2;
          return;
        }

        if (value.indexOf('content') !== -1) {
          sectionsContent = sectionsContent + 1;
        }
      });
      if (sections2Content > 0 || sectionsContent > 0) {
        // eslint-disable-next-line fp/no-mutating-methods
        sections.push({
          sectionResourceCount: sections2Content + sectionsContent,
        });
      }
    });

  return sections.length > 0 ? JSON.stringify(sections) : null;
};

export const isNewslettersSync = (
  nlfNewsletters: NlfNewsletters[],
  newsletters: GetNewslettersQuery_newsletters_Newsletter[],
) => {
  let isSync = true;
  newsletters.forEach((newsletter) => {
    nlfNewsletters.forEach((nlfNewsletter) => {
      if (nlfNewsletter.name === newsletter.nlfName) {
        const stringifyNlfNewsletter = extractSectionData(
          nlfNewsletter.sections,
        );
        if (stringifyNlfNewsletter !== newsletter.sections) {
          isSync = false;
        }
      }
    });
  });
  return isSync;
};
